const ALLOWED_SYMBOLS_REGEXP = new RegExp("[A-Za-z0-9 -]");

type ValidationPayload = true | string;

const allowedSymbolsRule = (value: string, _): ValidationPayload =>
    value.split("").every((char) => ALLOWED_SYMBOLS_REGEXP.test(char)) ||
    "Only alphanumeric and allowed symbols are allowed";

const LENGTH_LIMIT = 30;

const maximumLengthRule = (value: string, _): ValidationPayload =>
    value.length <= LENGTH_LIMIT || "Header title only 30 characters or less are allowed";

const minimumLengthRule = (value: string, _): ValidationPayload => Boolean(value) || "Header title cannot be empty";

const uniquinessRule = (value: string, collectionDisplayNames: Record<string, string>) =>
    !collectionDisplayNames[value] || "Custom UDA fields have to be unique within the assortment";

const rules = [minimumLengthRule, maximumLengthRule, allowedSymbolsRule, uniquinessRule];

export const validateInput = (input: string, collectionDisplayNames: Record<string, string>): ValidationPayload =>
    rules.reduce(
        (acc, rule) => (typeof acc === "string" ? acc : rule(input, collectionDisplayNames)),
        true as ValidationPayload
    );
